import Seo from "@/components/site/Seo";
import SpecialistCTA from "@/components/site/SpecialistCTA";
import { CheckCircle2, ShieldCheck, PhoneCall } from "lucide-react";

const POINTS = [
  { icon: PhoneCall, title: "We prep and guide", body: "A specialist reviews your issue, finds the right official channel, and coaches you through the menus so you reach a human faster." },
  { icon: ShieldCheck, title: "Independent & safe", body: "We never take over your account or ask for passwords, card numbers or one-time codes. We help you contact the brand — we're not the brand." },
  { icon: CheckCircle2, title: "One flat price", body: "Describe your issue in chat first — your first message is free. Then pay ($29 standard) and a specialist picks up your chat live." },
];

export default function ExpertHelp() {
  return (
    <div className="pb-16">
      <Seo
        title="Get Expert Help — It's Genie Assist"
        description="Optional paid concierge: an It's Genie Assist specialist helps you navigate a brand's customer service. Independent — the official contacts on our site are always free."
      />
      <section className="border-b border-hair py-12 sm:py-16">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-accent">Paid concierge</p>
        <h1 className="mt-3 max-w-3xl font-serif text-4xl font-medium leading-tight tracking-tight text-ink sm:text-5xl">
          Talk to our specialist.
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted sm:text-lg">
          Stuck in a phone tree or not sure who to call? Our specialists do this all day. For a flat
          $29 we&apos;ll help you prepare and get to the right official support — fast. This is an
          optional service from It&apos;s Genie Assist; every phone number and link elsewhere on this
          site stays free.
        </p>
      </section>

      <section className="grid gap-px bg-hair md:grid-cols-3">
        {POINTS.map((p) => (
          <div key={p.title} className="bg-paper p-6 sm:p-8">
            <p.icon className="h-6 w-6 text-accent" strokeWidth={1.75} />
            <h2 className="mt-4 font-serif text-xl font-medium text-ink">{p.title}</h2>
            <p className="mt-2 text-sm leading-relaxed text-muted">{p.body}</p>
          </div>
        ))}
      </section>

      <section className="mt-12">
        <SpecialistCTA />
      </section>
    </div>
  );
}
